import Vue from "vue";

Vue.component(
  "request-index",
  require("./Components/Views/Client/Buyer/Request/Index").default
);
Vue.component(
  "request-card",
  require("./Components/Views/Client/Buyer/Request/RequestCard").default
);
Vue.component(
  "request-profile",
  require("./Components/Views/Client/Buyer/Request/Profile").default
);
Vue.component(
  "request-profile-view",
  require("./Components/Views/Client/Buyer/Request/ProfileView").default
);
Vue.component(
  "certificate-view",
  require("./Components/Views/SuperAdmin/Client/Buyer/Request/CertificateViewModal").default
);
Vue.component(
  "request-profile-forms",
  require("./Components/Views/Client/Buyer/Request/Forms").default
);
Vue.component(
  "request-profile-status",
  require("./Components/Views/Client/Buyer/Request/Status").default
);
Vue.component(
  "buyer-certificate-request-view-modal",
  require("./Components/Views/SuperAdmin/Client/Buyer/Request/FormViewModal").default
);
Vue.component(
  "mybuyers-index",
  require("./Components/Views/Client/Buyer/MyBuyers/Index").default
);
Vue.component(
  "mybuyers-card",
  require("./Components/Views/Client/Buyer/MyBuyers/MyBuyersCard").default
);

Vue.component(
  "support-index",
  require("./Components/Views/Client/Buyer/Support/Index").default
);
Vue.component(
  "support-create",
  require("./Components/Views/Client/Buyer/Support/Create").default
);

Vue.component(
  "auditrequest-create",
  require("./Components/Views/Client/Buyer/AuditRequest/Create").default
);
Vue.component(
  "auditrequest-addmodal",
  require("./Components/Views/Client/Buyer/AuditRequest/AddModal").default
);

Vue.component(
  "company-create",
  require("./Components/Views/Client/Buyer/Company/Create").default
);
Vue.component(
  "company-upload",
  require("./Components/Views/Client/Buyer/Company/UploadModal").default
);
Vue.component(
  "company-profile-view",
  require("./Components/Views/Client/Buyer/Company/ProfileView").default
);

Vue.component(
  "job-mainstep",
  require("./Components/Views/Client/Buyer/Job/MainStep").default
);
Vue.component(
  "job-index",
  require("./Components/Views/Client/Buyer/Job/Index").default
);
Vue.component(
  "job-myjobs",
  require("./Components/Views/Client/Buyer/Job/MyJob").default
);
Vue.component(
  "job-create",
  require("./Components/Views/Client/Buyer/Job/Add").default
);
Vue.component(
  "job-edit",
  require("./Components/Views/Client/Buyer/Job/Edit").default
);
Vue.component(
  "job-site-edit",
  require("./Components/Views/Client/Buyer/Job/SiteEdit").default
);
Vue.component(
  "job-site-task-edit",
  require("./Components/Views/Client/Buyer/Job/TaskEdit").default
);


Vue.component(
  "job-addmodal",
  require("./Components/Views/Client/Buyer/Job/AddModal").default
);
Vue.component(
  "job-view",
  require("./Components/Views/Client/Buyer/Job/View").default
);
Vue.component(
  "job-inprogress",
  require("./Components/Views/Client/Buyer/Job/Inprogress").default
);
Vue.component(
  "job-chat",
  require("./Components/Views/Client/Buyer/Job/Chat").default
);
Vue.component(
  "job-notes",
  require("./Components/Views/Client/Buyer/Job/Notes").default
);
Vue.component(
  "job-bids",
  require("./Components/Views/Client/Buyer/Job/Bids").default
);
Vue.component(
  "job-bid-detailmodal",
  require("./Components/Views/Client/Buyer/Job/Bid/BidDetailModal").default
);

Vue.component(
  "job-bids-accepted",
  require("./Components/Views/Client/Buyer/Job/Bid/Accepted").default
);
Vue.component(
  "job-bids-rejected",
  require("./Components/Views/Client/Buyer/Job/Bid/Rejected").default
);
Vue.component(
  "job-bids-pending",
  require("./Components/Views/Client/Buyer/Job/Bid/Pending").default
);

Vue.component(
  "job-management",
  require("./Components/Views/Client/Buyer/Job/JobManagement").default
);
Vue.component(
  "job-document",
  require("./Components/Views/Client/Buyer/Job/Document").default
);
Vue.component(
  "job-info",
  require("./Components/Views/Client/Buyer/Job/Info").default
);
Vue.component(
  "job-site",
  require("./Components/Views/Client/Buyer/Job/JobSite").default
);
Vue.component(
  "job-search",
  require("./Components/Views/Client/Buyer/Job/Search").default
);
Vue.component(
  "job-view-modal",
  require("./Components/Views/Client/Buyer/Job/JobViewModal").default
);
Vue.component(
  "job-view-detail",
  require("./Components/Views/Client/Buyer/Job/ViewJobDetail").default
);
Vue.component(
  "job-bid-form",
  require("./Components/Views/Client/Buyer/Job/BidForm").default
);
Vue.component(
  "job-bid",
  require("./Components/Views/Client/Buyer/Job/Bid").default
);
Vue.component(
  "job-bid-view",
  require("./Components/Views/Client/Buyer/Job/JobBid").default
);
Vue.component(
  "site-view",
  require("./Components/Views/Client/Buyer/Job/Site/View").default
);
Vue.component(
  "site-create",
  require("./Components/Views/Client/Buyer/Job/Site/Create").default
);
Vue.component(
  "site-editmodal",
  require("./Components/Views/Client/Buyer/Job/Site/EditModal").default
);
Vue.component(
  "site-taskeditmodal",
  require("./Components/Views/Client/Buyer/Job/Site/TaskEditModal").default
);
Vue.component(
  "site-taskaddmodal",
  require("./Components/Views/Client/Buyer/Job/Site/TaskAddModal").default
);
Vue.component(
  "job-site-task-update",
  require("./Components/Views/Client/Buyer/Job/Site/TaskEdit").default
);
Vue.component(
  "site-list",
  require("./Components/Views/Client/Buyer/Job/Site/List").default
);

Vue.component(
  "job-site-assign-usermodal",
  require("./Components/Views/Client/Buyer/Job/Site/AssignUserModal").default
);

Vue.component(
  "job-card",
  require("./Components/Views/Client/Buyer/Job/JobCard").default
);
Vue.component(
  "job-grid",
  require("./Components/Views/Client/Buyer/Job/JobGrid").default
);
Vue.component(
  "job-detail",
  require("./Components/Views/Client/Buyer/Job/Detail").default
);

Vue.component(
  "job-response-card",
  require("./Components/Views/Client/Buyer/Job/Bid/ResponseCard").default
);
Vue.component(
  "job-response-grid",
  require("./Components/Views/Client/Buyer/Job/Bid/ResponseGrid").default
);
Vue.component(
    "ResponseGrid",
    require("@Views/SuperAdmin/Task/Form/ResponseGrid").default
);
Vue.component(
    "ResponseGridCard",
    require("@Views/SuperAdmin/Task/Form/ResponseGridCard").default
);
// Vue.component(
//   "job-site",
//   require("./Components/Views/Client/Buyer/Job/Site/Index").default
// );
Vue.component(
  "job-site-detail",
  require("./Components/Views/Client/Buyer/Job/Site/Detail").default
);
Vue.component(
  "job-site-loginactivity",
  require("./Components/Views/Client/Buyer/Job/Site/LoginActivity").default
);
Vue.component(
  "job-site-activity",
  require("./Components/Views/Client/Buyer/Job/Site/SiteActivity").default
);
Vue.component(
  "job-site-assignment",
  require("./Components/Views/Client/Buyer/Job/Site/Assignment").default
);
Vue.component(
  "job-site-public",
  require("./Components/Views/Client/Buyer/Job/Site/PublicSite").default
);
Vue.component(
  "job-site-private",
  require("./Components/Views/Client/Buyer/Job/Site/PrivateSite").default
);
Vue.component(
  "dropdown-index",
  require("./Components/Views/Client/Buyer/Job/Dropdown/Index").default
);
Vue.component(
  "dropdown-addmodal",
  require("./Components/Views/Client/Buyer/Job/Dropdown/AddModal").default
);
Vue.component(
  "bid-formviewmodal",
  require("./Components/Views/Client/Buyer/Job/BidFormViewModal").default
);
Vue.component(
  "responses-index",
  require("./Components/Views/Client/Buyer/Forms/Responses/Index").default
);
Vue.component(
  "responses-card",
  require("./Components/Views/Client/Buyer/Forms/Responses/ResponseCard")
    .default
);
Vue.component(
  "response-view",
  require("./Components/Views/Client/Buyer/Forms/View").default
);
Vue.component(
  "myforms-index",
  require("./Components/Views/Client/Buyer/Forms/MyForms/Index").default
);
Vue.component(
  "myforms-addmodal",
  require("./Components/Views/Client/Buyer/Forms/MyForms/AddModal").default
);

Vue.component(
  "questioner-index",
  require("./Components/Views/Client/Buyer/Questioner/Index").default
);
Vue.component(
  "questioner-card",
  require("./Components/Views/Client/Buyer/Questioner/QuestionerCard").default
);
Vue.component(
  "questioner-view",
  require("./Components/Views/Client/Buyer/Questioner/View").default
);
Vue.component(
  "questioner-products",
  require("./Components/Views/Client/Buyer/Questioner/Products").default
);
Vue.component(
  "questioner-review",
  require("./Components/Views/Client/Buyer/Questioner/Review").default
);
Vue.component(
  "compliance-certificate-certificates",
  require("./Components/Views/Client/Buyer/ComplianceCertificate/Certificates")
    .default
);
Vue.component(
  "job-users",
  require("./Components/Views/Client/Buyer/Job/Users").default
);

Vue.component(
  "job-bidaddmodal",
  require("./Components/Views/Client/Buyer/Job/BidAddModal").default
);
Vue.component(
  "certificate-management",
  require("./Components/Views/Client/Buyer/Certificate/CertificateManagement")
    .default
);
Vue.component(
  "certificate-certificates",
  require("./Components/Views/Client/Buyer/Certificate/Certificate").default
);

Vue.component(
  "certificate-applied",
  require("./Components/Views/Client/Buyer/Certificate/AppliedCertificates")
    .default
);

Vue.component(
  "certificate-applied-details",
  require("./Components/Views/Client/Buyer/Certificate/AppliedDetail").default
);
Vue.component(
  "certificate-details",
  require("./Components/Views/Client/Buyer/Certificate/Details").default
);

Vue.component(
  "certificate-forms",
  require("./Components/Views/Client/Buyer/Certificate/Forms").default
);

Vue.component(
  "certificate-forms-view-modal",
  require("./Components/Views/Client/Buyer/Certificate/FormViewModal").default
);

Vue.component(
  "certificate-detail-view-modal",
  require("./Components/Views/Client/Buyer/Certificate/ViewCertificateModal")
    .default
);

Vue.component(
  "job-review-index",
  require("./Components/Views/Client/Buyer/Job/Review/Index").default
);

Vue.component(
  "job-review-review",
  require("./Components/Views/Client/Buyer/Job/Review/Review").default
);
Vue.component(
  "job-review-feedback",
  require("./Components/Views/Client/Buyer/Job/Review/Feedback").default
);
Vue.component(
  "job-review",
  require("./Components/Views/Client/Buyer/Job/Review").default
);

//My Job Management
Vue.component(
  "myjob-mainstep",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/MainStep").default
);
Vue.component(
  "myjob-index",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Index").default
);
Vue.component(
  "myjob-index-information",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Information").default
);
Vue.component(
  "myjob-index-site",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Site/View").default
);
Vue.component(
  "myjob-index-site-list",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Site/List").default
);
Vue.component(
  "myjob-site-attach-documentmodal",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Site/AttachDocumentModal").default
);
Vue.component(
  "myjob-index-document",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Document").default
);
Vue.component(
  "myjob-index-chat",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Chat").default
);
Vue.component(
  "myjob-index-notes",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Notes").default
);
Vue.component(
  "myjob-review",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Review").default
);
Vue.component(
  "myjob-review-formmodal",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/FormViewModal").default
);

Vue.component(
  "myjob-index-review-index",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Review/Index").default
);

Vue.component(
  "myjob-index-review",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Review/Index").default
);

Vue.component(
  "myjob-index-review-review",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Review/Review").default
);
Vue.component(
  "myjob-index-review-feedback",
  require("./Components/Views/Client/Buyer/Job/MyJobManagement/Review/Feedback").default
);

//supplier
Vue.component(
  "supplier-taskmodal",
  require("./Components/Views/SuperAdmin/Client/Supplier/AddModal").default
);
Vue.component(
  "supplier-shortlisted",
  require("./Components/Views/SuperAdmin/Client/Supplier/Shortlisted").default
);

//MY Documents
Vue.component(
  "mydocument-index",
  require("./Components/Views/Client/Buyer/MyDocument/Index").default
);

Vue.component(
  "mydocument-addmodal",
  require("./Components/Views/Client/Buyer/MyDocument/AddModal").default
);

Vue.component(
  "mydocument-viewmodal",
  require("./Components/Views/Client/Buyer/MyDocument/ViewModal").default
);

//Certificate
Vue.component(
  "certificate-category-index",
  require("./Components/Views/SuperAdmin/Certificate/Category/Index").default
);
Vue.component(
  "certificate-category-addmodal",
  require("./Components/Views/SuperAdmin/Certificate/Category/AddModal").default
);

Vue.component(
  "certificate-list",
  require("./Components/Views/SuperAdmin/Certificate/List").default
);
Vue.component(
  "certificate-list-addmodal",
  require("./Components/Views/SuperAdmin/Certificate/AddModal").default
);



Vue.component('CompanyReport', require('./Components/Views/CompanyReports/index').default);

Vue.component('AddReport', require('./Components/Views/CompanyReports/AddReport').default);

Vue.component('TaskReport', require('./Components/Views/CompanyReports/TaskReport').default);
//MY Site
Vue.component(
  "mysite-index",
  require("./Components/Views/Client/Buyer/Job/MySite/Index").default
);
Vue.component(
  "mysite-viewmodal",
  require("./Components/Views/Client/Buyer/Job/MySite/SiteViewModal").default
);
Vue.component(
  "mysite-information",
  require("./Components/Views/Client/Buyer/Job/MySite/Information").default
);
Vue.component(
  "mysite-task",
  require("./Components/Views/Client/Buyer/Job/MySite/Task").default
);
Vue.component(
    "site-log-book",
    require("./Components/Views/Client/Buyer/Job/MySite/SiteLogBook").default
);
Vue.component(
    "site-checkin",
    require("./Components/Views/Client/Buyer/Job/MySite/SiteCheckin").default
);
Vue.component(
    "check-in-form",
    require("./Components/Views/Client/Buyer/Job/MySite/CheckinForm").default
);
Vue.component(
  "site-check-call",
  require("./Components/Views/Client/Buyer/Job/MySite/SiteCheckCall").default
);
Vue.component(
  "mysite-task-edit",
  require("./Components/Views/Client/Buyer/Job/MySite/EditTask").default
);

Vue.component(
  "mysite-site-document-endore-modal",
  require("./Components/Views/Client/Buyer/Job/MySite/SiteDocumentEndorseModal").default
);
Vue.component(
  "allbuyers-index",
  require("./Components/Views/SuperAdmin/Client/AllBuyers/Index").default
);
Vue.component(
  "buyer-shortlisted",
  require("./Components/Views/SuperAdmin/Client/AllBuyers/Shortlisted").default
);

//Notification SideBar
Vue.component(
  "notification-index",
  require("./../core/components/layouts/notification/Index").default
);

//Chat Modal
Vue.component(
  "chat-modal",
  require("./../core/components/layouts/ChatModal").default
);

//ShortCut Navigation
Vue.component(
  "shortcut-navigation",
  require("./../core/components/layouts/ShortCutNavigation").default
);
//User ShortCut Screen

Vue.component(
  "shortcut-user-create",
  require("./Components/Views/UserRoles/Users/CreateUser").default
);

Vue.component('save-form-wizard', require('./Components/Views/SaveForm/wizard').default);

// Vue.prototype.$hub = new Vue(); //NOTE: Cause its already imported in coreApp.js